<div id="container">
    <div id="title" routerLink="/calendar">Monthly View</div>
    <div id="separator"></div>
    <div id="title" routerLink="/time">Weekly View</div>
    <div id="separator"></div>
    <div id="title" routerLink="/daily">Daily View</div>
    <div id="separator"></div>
    <div id="title" routerLink="/overdue">Overdue</div>
</div>